import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';
import {getRelationship, listRelationships, listLogicalModels} from '../utils/utilsLogicalModel';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 



class SelectRelationship extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectLogicalModel: false,
            label: "Relationship",
            idSelected: "",
            idLogicalModel: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectLogicalModel = getParam('selectLogicalModel',this.props);
        StateChange.idLogicalModel = getParam('idLogicalModel', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectLogicalModel){
            this.loadLogicalModels();
        }

        if (StateChange.idLogicalModel){
            this.loadRelationships(StateChange.idLogicalModel);
        }

        if (StateChange.idSelected){
            this.loadSelectedRelationship(StateChange.idSelected);
        }

        this.setState(StateChange);

    }

    loadSelectedRelationship(idRelationship){

        if (!idRelationship){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Relationship) => {
            const StateChange = {
                SelectedRelationship: Relationship,
                renderState: "loaded"
            };
            
            if (Relationship.LogicalModel){
                StateChange.idLogicalModel = Relationship.LogicalModel._id;
                this.loadRelationships(StateChange.idLogicalModel);
            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load relationship"
            });
        };

        getRelationship(this.dsd, idRelationship, onLoad, onFail);
        
    };



    loadRelationships(idLogicalModel){

        if (!idLogicalModel){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (relationships) => {
            this.setState({
                Relationships: relationships,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load relationships"
            });
        };

        listRelationships(this.dsd, {idLogicalModel: idLogicalModel}, onLoad, onError);
        
    };


    loadLogicalModels(){

        this.setState({renderState: "loading"});

        const onLoad = (logicalModels) => {
            this.setState({
                LogicalModels: logicalModels,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load logical models"
            });
        };

        listLogicalModels(this.dsd, {}, onLoad, onError);
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idLogicalModel":
                this.setState({"idLogicalModel":FormFieldValue});
                if (FormFieldValue){
                    this.loadRelationships(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectLogicalModel && this.state.LogicalModels &&
                            <PD.Select label='Select a Logical Model' name='idLogicalModel' onChange={this.handleChange} value={this.state.idLogicalModel}>
                                {
                                    this.state.LogicalModels.map(
                                        (LogicalModel, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={LogicalModel._id}>{LogicalModel.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.Relationships &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Relationships.map(
                                        (Relationship, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Relationship._id}>{Relationship.label}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectRelationship_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectRelationship {...props} navigation={navigation} location={location} params={params} />;
  }
